<template>
  <div class="wrap">
    <img :src="img" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default:
        "https://faststatic.ccnfgame.com/cos/vrshow/autoshow/banner_5_1.png",
    },
  },
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
img {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// myImg.vue?01ba1126